import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-dv-werkrooster',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-dv-werkrooster.component.html',
  styleUrl: './tekst-dv-werkrooster.component.scss',
})
export class TekstDvWerkroosterComponent {}
